import React, { useState, useContext, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "rc-time-picker/assets/index.css";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import DatePickerInput from "./SubComponents/Date";
import TimePickerInput from "./SubComponents/Time";
import CitySuggestionsCMP from "./SubComponents/SuggetionsDrop";
import AirportSuggestionsCMP from "./SubComponents/Airports";
import { useNavigate } from "react-router-dom";
import { SwapCityContext } from "../Context/SwapContext";
import moment from 'moment';
import toast from "react-hot-toast";

const AirPortSearchTab = ({ tripType }) => {

    const { to_city, setTo_city, from_city, setFrom_city, swapStatus, setSwapStatus, setFromContextCity } = useContext(SwapCityContext);
    const [check, setCheck] = useState(false);


    // use navigation for redirect the another page
    const Navigation = useNavigate();

    // handle data and Times
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [formData, setFormData] = useState({
        from_city: "",
        from_city_id: "",
        from_state_id: "",
        from_state_name: "",
        trip_type: tripType,
        to_city: "",
        to_city_id: "",
        to_state_id: "",
        to_state_name: "",
        pickup_date: '',
        pickup_time: '',
        drop_date: "",
        package: '',
        package_id: '',
        vehicle_name: "",
        vehicle_id: "",
        pickup_drop: "",
    });

    const HandleChangesData = (DataObject) => {
        for (let property in DataObject) {
            formData[property] = DataObject[property]
        }

        // save the formatted Data
        setFormData({
            ...formData
        })
    }

    useEffect(() => {
        let GetLocalDb = JSON.parse(localStorage.getItem('cab_listing')) || {};
        if (GetLocalDb.trip_type === tripType) {
            HandleChangesData(GetLocalDb)
        }
    }, [])

    // handle submit handle tab
    const CabSearchSubmit = (e) => {
        // handle changes data
        e.preventDefault();
        //
        if (formData.from_city === '' || formData.from_city.length < 1) {
            toast.error("Please select the pickup location")
            return;
        }
        if (formData.to_city === '' || formData.to_city < 1) {
            toast.error("Please select the drop location")
            return;
        }

        if (formData.pickup_date.length < 1 || formData.pickup_date === '') {
            toast.error("Please select the pickup date")
            return;
        }

        if (formData.pickup_time.length < 1 || formData.pickup_time === '') {
            toast.error("Please select the pickup time")
            return;
        }

        const currentMoment = moment();
        // Extract date strings for comparison in YYYY-MM-DD format
        const selectedDateStr = moment(formData.pickup_date).format('YYYY-MM-DD');
        const currentDateStr = currentMoment.format('YYYY-MM-DD');

        let selectedMoment;
        if (selectedDateStr === currentDateStr) {
            // If the selected date is today, combine the date and pickup time (e.g., "2025-03-26 5:30 PM")
            selectedMoment = moment(`${selectedDateStr} ${formData.pickup_time}`, 'YYYY-MM-DD h:mm A');
        } else {
            // For future dates, assume formData.pickup_date contains full date-time information
            selectedMoment = moment(formData.pickup_date);
        }

        // Calculate the time difference in hours (floating point)
        const timeDifference = selectedMoment.diff(currentMoment, 'hours', true);

        setFromContextCity(null)
        // remove the current localstorage and override the data
        localStorage.removeItem('cab_listing');
        // save the data in localstorage for now
        localStorage.setItem('cab_listing', JSON.stringify(formData));
        Navigation('/cab-listing')
    }

    return (
        <Form onSubmit={(e) => CabSearchSubmit(e)}>
            <div className="d-flex mb-3 gap-2 justify-content-between">
                <Form.Group controlId="pickupLocation" className="pichupDropSelect">
                    <Form.Label className="">Select Pickup / Drop</Form.Label>
                    <Form.Select as="select" placeholder="Enter location" className="form-control noiconfield" value={formData.pickup_drop} onChange={(e) => {
                        setFormData({ ...formData, pickup_drop: e.target.value });
                    }}>
                        <option value="">Select Pickup / Drop Type</option>
                        <option value="pickup">Pickup From Airport</option>
                        <option value="drop">Drop To Airport</option>
                    </Form.Select>
                </Form.Group>
                {
                    formData.pickup_drop === 'pickup' ? (
                        <>
                            <AirportSuggestionsCMP handleFormatted={HandleChangesData} tripType={tripType} formData={formData} />
                            <CitySuggestionsCMP handleFormatted={HandleChangesData} tripType={tripType} formData={formData} />
                        </>
                    ) : (
                        <>
                            <CitySuggestionsCMP handleFormatted={HandleChangesData} tripType={tripType} formData={formData} />
                            <AirportSuggestionsCMP handleFormatted={HandleChangesData} tripType={tripType} formData={formData} />
                        </>
                    )
                }
                {/* <CitySuggestionsCMP handleFormatted={HandleChangesData} tripType={tripType} formData={formData} />
                {/* <SwapCityCMP /> */}
                {/* <AirportSuggestionsCMP handleFormatted={HandleChangesData} tripType={tripType} formData={formData} />  */}
                <DatePickerInput handleFormatted={HandleChangesData} setSelectedDate={setSelectedDate} tripType={tripType} setCheck={setCheck} />
                <TimePickerInput handleFormatted={HandleChangesData} selectedDateInput={selectedDate} tripType={tripType} />
            </div>
            <div className="softwbtn text-center">
                <Button variant="primary" type="submit">
                    Search Cab <img
                        src="/images/search.png"
                        alt="Search Icon"
                        title="Search"
                        loading="lazy"
                        width={20} height={20}
                        style={{ width: "revert-layer", height: "auto" }}
                    />
                </Button>
            </div>
        </Form>

    )
}


export default AirPortSearchTab